import { ContentWorkflow } from '@amzn/awscat-pattern-library-service-model';
import { Icon, Popover } from '@amzn/awsui-components-core';
import React from 'react';
import ContentNotesDetails from './ContentNotesDetails';

interface Props {
  workflow: ContentWorkflow;
  notesCount?: number;
}

const ContentNotesPopover = ({ notesCount, workflow }: Props) => {
  const contentNotesDetails = <ContentNotesDetails workflow={workflow} />;
  const iconElement = notesCount ? (
    <span>
      <Icon name="contact" size="normal" variant="link" />
      {notesCount}
    </span>
  ) : (
    <Icon name="contact" size="normal" variant="normal" />
  );
  return (
    <Popover
      dismissAriaLabel="Close"
      fixedWidth
      size="large"
      triggerType="custom"
      renderWithPortal
      content={contentNotesDetails}
    >
      {iconElement}
    </Popover>
  );
};

export default ContentNotesPopover;
